import { Activity, CalendarDays, List, Settings } from 'lucide-react';

export const NAV_ITEMS = [
  { to: '/', label: 'FITNESS', Icon: Activity, exact: true },
  { to: '/calendar', label: 'CALENDAR', Icon: CalendarDays, exact: false },
  { to: '/activities', label: 'ACTIVITIES', Icon: List, exact: false },
  { to: '/settings', label: 'SETTINGS', Icon: Settings, exact: false },
] as const;
